import tw, { css, styled, theme } from 'twin.macro';

const BackgroundStyle = css`
  ${tw`absolute h-full w-full inset-0`}
  z-index: -1;
`;

const imageUrl = 'https://ik.imagekit.io/yela/Production/About_Us/';
const imageUrlLow = `${imageUrl}/tr:q-80,w-1080,h-600,c-at_least,lo-true,fo-custom/NEWEST_-_collage_wOqMAVz2M.png`;
const imageUrlHigh = `${imageUrl}/tr:q-80,w-1440,h-800,c-at_least,lo-true,fo-custom/NEWEST_-_collage_wOqMAVz2M.png`;

export const HeroCollageSection = styled.div<{ children: JSX.Element }>`
  ${BackgroundStyle}
  background: radial-gradient(rgba(7, 7, 8, 0.9) 0%, rgba(7, 7, 8, 0.98) 100%), url(${imageUrlLow}) center/cover no-repeat;

  @media only screen and (min-width: ${theme`screens.lg.min`}) {
    background: radial-gradient(rgba(7, 7, 8, 0.98) 0%, rgba(7, 7, 8, 0.98) 100%), url(${imageUrlHigh}) center/cover no-repeat;
  }
`;

export const HeroCollageTorch = styled.div<{ children?: JSX.Element }>`
  ${BackgroundStyle}
  --torchX: 45%;
  --torchY: 45%;
  display: inline-block;
  background: radial-gradient(rgba(7, 7, 8, 0.6) 0%, rgba(7, 7, 8, 0.98) 100%), url(${imageUrlLow}) center/cover no-repeat;

  mask-image: radial-gradient(ellipse 35vmax 35vmax at 55.31% 34.69%, black 25%, transparent 60%);

  -webkit-mask-image: radial-gradient(ellipse 35vmax 35vmax at 55.31% 34.69%, black 25%, transparent 60%);

  @media only screen and (min-width: ${theme`screens.lg.min`}) {
    background: radial-gradient(rgba(7, 7, 8, 0.6) 0%, rgba(7, 7, 8, 0.98) 100%), url(${imageUrlHigh}) center/cover no-repeat;

    mask-image: radial-gradient(ellipse 35vmax 35vmax at var(--torchX) var(--torchY), black 25%, transparent 60%);

    -webkit-mask-image: radial-gradient(ellipse 35vmax 35vmax at var(--torchX) var(--torchY), black 25%, transparent 60%);
  }
`;
